// extracted by mini-css-extract-plugin
export default {"recurringFormContainer":"insuranceForm_recurringFormContainer__TodA0"};